import { compose, withState, withHandlers } from 'recompose';
import { Cache } from 'aws-amplify';

export type ThemerProps = {
  theme: string;
  updateTheme: () => void;
};

export const withThemer = compose(
  withState('theme', 'setTheme', () => Cache.getItem('theme') || 'dark'),
  withHandlers({
    updateTheme: ({ setTheme }) => (event: any) => {
      const { value } = event.currentTarget;
      Cache.setItem('theme', value);
      setTheme(value);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/helpers/withThemer.tsx